"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _RadioBlock = _interopRequireDefault(require("../RadioBlock"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\theight: 12px;\n\twidth: 12px;\n\tborder-radius: 50%;\n\tbackground-color: ", ";\n\t", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\theight: 24px;\n\twidth: 24px;\n\tborder-radius: 50%;\n\tmargin-right: ", ";\n\tborder: 2px solid ", ";\n\tbackground-color: ", ";\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding: ", " ", " ", " ", ";\n\tborder: 2px solid ", ";\n\tfont-weight: bold;\n\tdisplay: flex;\n\talign-items: center;\n\tbox-shadow: none;\n\theight: 44px;\n\tflex-shrink: 0;\n\tfont-size: 14px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\n\t> * {\n\t\tmargin-right: ", ";\n\t\t&:last-child {\n\t\t\tmargin-right: 0;\n\t\t}\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Wrapper = _styledComponents.default.div(_templateObject(), _spacing.default.s2);

Wrapper.displayName = 'Wrapper';
var Block = (0, _styledComponents.default)(_RadioBlock.default)(_templateObject2(), _spacing.default.s1, _spacing.default.s2, _spacing.default.s1, _spacing.default.s1, _colors.default.primary);
Block.displayName = 'Block';

var Outside = _styledComponents.default.div(_templateObject3(), _spacing.default.s1, _colors.default.primary, _colors.default.white);

Outside.displayName = 'Outside';

var Inside = _styledComponents.default.div(_templateObject4(), _colors.default.primary, function (props) {
  return !props.selected && 'display: none';
});

Inside.displayName = 'Inside';

var Options = function Options(_ref) {
  var selectedValue = _ref.selectedValue,
      options = _ref.options,
      _onChange = _ref.onChange,
      rest = _objectWithoutPropertiesLoose(_ref, ["selectedValue", "options", "onChange"]);

  return _react.default.createElement(Wrapper, rest, options.map(function (_ref2) {
    var label = _ref2.label,
        value = _ref2.value,
        e2e = _ref2.e2e,
        disabled = _ref2.disabled;
    return _react.default.createElement(Block, {
      checked: value === selectedValue,
      onChange: function onChange() {
        _onChange(value);
      },
      name: value,
      value: value,
      "data-e2e": e2e || value,
      key: value,
      disabled: disabled,
      role: "radio"
    }, _react.default.createElement(Outside, {
      selected: value === selectedValue
    }, _react.default.createElement(Inside, {
      "data-testid": "inside",
      selected: value === selectedValue
    })), label);
  }));
};

Options.displayName = 'Options';
Options.propTypes = {
  onChange: _propTypes.func.isRequired,
  options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    label: _propTypes.string.isRequired,
    value: _propTypes.string.isRequired,
    e2e: _propTypes.string,
    disabled: _propTypes.bool
  })).isRequired,
  selectedValue: _propTypes.string
};
Options.defaultProps = {
  selectedValue: undefined
};
var _default = Options;
exports.default = _default;